import React from 'react';
import styled from 'styled-components';
import {useParams, Link, useLocation} from 'react-router-dom';
import {Breadcrumb} from 'components/antd';
import Title from './Title';
import {useMailCampaignQuery} from 'api';
import Prospects from './Prospects';
import Preleads from './Preleads';
import {RecoilRoot} from 'recoil';

export default () => {
  const {mailCampaignId} = useParams<{
    mailCampaignId: string;
  }>();
  const location = useLocation();

  const {
    data: {mailCampaign = null} = {},
    startPolling,
    stopPolling,
  } = useMailCampaignQuery({
    variables: {uuid: mailCampaignId},
    skip: !mailCampaignId,
  });

  // キャンセルの実処理はジョブで行うため、完了して下書きに戻るまで状態を取り直す
  React.useEffect(() => {
    if (mailCampaign?.status === 'cancelling') {
      startPolling(3000);
    } else {
      stopPolling();
    }
  }, [mailCampaign?.status, startPolling, stopPolling]);

  if (!mailCampaign) return null;

  return (
    <Container>
      <RecoilRoot>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/mail_campaigns${location.search}`}>〈 一覧に戻る</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
        <Title mailCampaign={mailCampaign} />
        {mailCampaign.target === 'prospects' && <Prospects />}
        {mailCampaign.target === 'preleads' && <Preleads />}
      </RecoilRoot>
    </Container>
  );
};

const Container = styled.div`
  padding: 30px;
  background: #f3f5f7;
  height: calc(100vh - 60px);
  overflow-y: scroll;
`;
